const BUYER_NAMES = [
  'Sarah Johnson',
  'Michael Chen',
  'Emily Rodriguez',
  'David Kim',
  'Jessica Martinez',
  'James Wilson',
  'Ashley Thompson',
  'Christopher Lee',
  'Amanda Garcia',
  'Matthew Anderson',
  'Jennifer Taylor',
  'Daniel Brown',
  'Lisa Davis',
  'Robert Miller',
  'Maria Hernandez',
  'William Moore',
  'Patricia Jackson',
  'Richard White',
  'Linda Harris',
  'Thomas Martin',
  'Karen Thompson',
  'Charles Garcia',
  'Nancy Martinez',
  'Joseph Robinson',
  'Margaret Clark',
  'Paul Lewis',
  'Sandra Walker',
  'Mark Hall',
  'Betty Allen',
  'Donald Young',
  'Helen King',
  'Steven Wright',
  'Donna Lopez',
  'Kenneth Hill',
  'Carol Scott',
  'Brian Green',
  'Michelle Adams',
  'Edward Baker',
  'Laura Nelson',
  'Kevin Carter',
]

const US_CITIES = [
  'New York, NY',
  'Los Angeles, CA',
  'Chicago, IL',
  'Houston, TX',
  'Phoenix, AZ',
  'Philadelphia, PA',
  'San Antonio, TX',
  'San Diego, CA',
  'Dallas, TX',
  'San Jose, CA',
  'Austin, TX',
  'Jacksonville, FL',
  'Fort Worth, TX',
  'Columbus, OH',
  'Charlotte, NC',
  'San Francisco, CA',
  'Indianapolis, IN',
  'Seattle, WA',
  'Denver, CO',
  'Boston, MA',
  'Nashville, TN',
  'Portland, OR',
  'Las Vegas, NV',
  'Detroit, MI',
  'Memphis, TN',
  'Louisville, KY',
  'Baltimore, MD',
  'Milwaukee, WI',
  'Albuquerque, NM',
  'Tucson, AZ',
  'Fresno, CA',
  'Sacramento, CA',
  'Kansas City, MO',
  'Atlanta, GA',
  'Miami, FL',
  'Raleigh, NC',
  'Omaha, NE',
  'Minneapolis, MN',
  'Cleveland, OH',
  'Tulsa, OK',
]

// Track recently used names to avoid immediate repeats
const recentNames: string[] = []
const MAX_RECENT_NAMES = 10

export function getRandomName(): string {
  // Filter out recently used names if possible
  const availableNames = BUYER_NAMES.filter(
    (name) => !recentNames.includes(name),
  )

  // If all names have been used recently, reset
  const namePool = availableNames.length > 0 ? availableNames : BUYER_NAMES

  const name = namePool[Math.floor(Math.random() * namePool.length)]

  // Add to recent names and maintain max size
  recentNames.push(name)
  if (recentNames.length > MAX_RECENT_NAMES) {
    recentNames.shift()
  }

  return name
}

export function getRandomCity(): string {
  return US_CITIES[Math.floor(Math.random() * US_CITIES.length)]
}
